import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

function FormInput({ bootstrapIcon, title, children, stylesIcon, bottomtext }) {
    return (
        <div className="customInput">
            <h3 className="titleStyle2">{title}</h3>
            <div className="input-group">
                <div className="input-group-prepend">
                    {bootstrapIcon && (
                        <span
                            className={`input-group-text ${
                                stylesIcon ? '' : bootstrapIcon
                            }`}
                            style={stylesIcon}
                        >
                            {stylesIcon ? <img src={bootstrapIcon} /> : null}
                        </span>
                    )}
                    {children}
                </div>
            </div>
            {bottomtext && <p className="bottomText">{bottomtext}</p>}
        </div>
    );
}

FormInput.propTypes = {
    // icon displayed besides form input
    bootstrapIcon: PropTypes.string,
    // title displayed on top of input (form label)
    title: PropTypes.string,
    stylesIcon: PropTypes.object,
    // components to be rendered inside
    children: PropTypes.node,
    bottomtext: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

FormInput.defaultProps = {
    bootstrapIcon: 'icon-flag',
    title: 'Challenges',
    children: null,
    stylesIcon: null,
    bottomtext: '',
};

export default FormInput;
